/* eslint-disable */
import Vue from "vue";

/**
 * 设置基础URL
 */
let base = "apiv1/hr/advice";

/**
 * 建议添加
 * @param {*} params
 */
export const add = params => {
  return Vue.fetch.post(`${base}/add`, params).then(data => {
    return data;
  });
};

/**
 * 建议列表
 * @param {*} params
 */
export const list = params => {
  return Vue.fetch.post(`${base}/list`, params).then(data => {
    return data;
  });
};

/**
 * 建议回复
 * @param {*} params
 */
export const replay = params => {
  return Vue.fetch.post(`${base}/replay`, params).then(data => {
    return data;
  });
};

/**
 * 建议删除
 * @param {*} params
 */
export const romove = params => {
  return Vue.fetch.post(`${base}/delete`, params).then(data => {
    return data;
  });
};



// WEBPACK FOOTER //
// ./src/services/adviceApi.js